<template>
	<div>
		<!-- 搜索条件区域 -->
		<div class="search-container">
			<div class="search-form">
				<div class="form-item">
					<span class="label">名称</span>
					<el-input v-model="queryParams.policyTitle" placeholder="请输入名称" clearable></el-input>
				</div>
				<div class="form-buttons">
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="handleResetSearch">重置</el-button>
					<el-button :disabled="multiple" type="primary" plain @click="handleRemoveAllCollect">
						批量取消收藏
					</el-button>
				</div>
			</div>
		</div>

		<!-- 列表区域 -->
		<data-table
			:table-data="useCollectPolicyList"
			:column="columns"
			:page-options="pageOptions"
			:border="true"
			:loading="loading"
			:selection="true"
			:reserve-selection="true"
			:row-keys="handleRowKeys"
			@selectionChange="handleSelectDataChange"
			@page-change="handlePaginationChange"
		>
			<template slot="tools" slot-scope="data">
				<el-button @click="handleRemoveCollect(data.scope.row)">取消收藏</el-button>
			</template>
		</data-table>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { pageUserCollectPolicy, removeUserCollect } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum'

	// 用户收藏的政策资讯信息
	export default {
		name: 'CollectPolicy',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				queryParams: {
					policyTitle: ''
				},
				columns: [
					{ label: '名称', prop: 'policyTitle', align: 'center' },
					{ label: '收藏日期', prop: 'collectTime', width: '180', align: 'center' },
					{ label: '操作', prop: '', align: 'center', width: '150', slot: 'tools' }
				],
				// 用户收藏的政策资讯信息
				useCollectPolicyList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 非多个禁用
				multiple: true,
				// 选中的id集合
				selectIds: []
			}
		},
		computed: {},
		watch: {},
		created() {
			this.getUserCollectPolicyList()
		},
		mounted() {},
		methods: {
			// 查询用户收藏的政策资讯信息
			getUserCollectPolicyList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				pageUserCollectPolicy(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							// 添加选择状态字段
							// this.useCollectPolicyList = data.records.map(item => ({
							// 	...item,
							// 	selected: false
							// }))
							this.useCollectPolicyList = data.records
							this.pageOptions.total = data.total || 0
						} else {
							this.useCollectPolicyList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.useCollectPolicyList = []
						this.pageOptions.total = 0
					})
			},

			handleRowKeys(row) {
				return row.id
			},

			// 选中回调
			handleSelectDataChange(selection) {
				this.selectIds = selection.map(item => item.id)
				this.multiple = !selection.length
			},

			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getUserCollectPolicyList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.getUserCollectPolicyList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					policyTitle: ''
				}
				this.getUserCollectPolicyList()
			},

			// 用户取消收藏
			handleRemoveCollect(item) {
				const data = {
					collectType: COLLECT_TYPE_STATE.NEWS,
					collectIds: [item.id]
				}
				removeUserCollect(data).then(response => {
					this.getUserCollectPolicyList()
				})
			},

			// 批量取消收藏
			handleRemoveAllCollect() {
				const selectedIds = this.selectIds

				const data = {
					collectType: COLLECT_TYPE_STATE.NEWS,
					collectIds: selectedIds
				}

				removeUserCollect(data).then(response => {
					this.getUserCollectPolicyList()
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
</style>
